
export const GA_MEASUREMENT_ID = "G-7KH8JZQDSF";

export const pageview = (url) => {
  // if (REACT_APP_MODE === "production") {
  //   window.gtag("config", GA_MEASUREMENT_ID, {
  //     page_path: url,
  //   });
  // }
};

export const trackEvent = ({ action, category, label, value }) => {
  // if (REACT_APP_MODE === "production") {
  //   window.gtag("event", action, {
  //     event_category: category,
  //     event_label: label,
  //     value: value,
  //   });
  // }
};
